import { render } from "./CustomersPage.vue?vue&type=template&id=21055f29&scoped=true"
import script from "./CustomersPage.vue?vue&type=script&lang=js"
export * from "./CustomersPage.vue?vue&type=script&lang=js"

import "./CustomersPage.vue?vue&type=style&index=0&id=21055f29&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21055f29"]])

export default __exports__